/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ n: NonNullable<unknown>, total: NonNullable<unknown> }} Shop_Group_In_Stock_CountInputs */

const vi_shop_group_in_stock_count = /** @type {(inputs: Shop_Group_In_Stock_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n}/${i?.total} loại còn hàng`)
};

/**

* @param {Shop_Group_In_Stock_CountInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_group_in_stock_count = /** @type {((inputs: Shop_Group_In_Stock_CountInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Group_In_Stock_CountInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_group_in_stock_count(inputs)
});